var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignUpPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E6EBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.7309 17.1019C18.424 17.1019 20.5819 14.9432 20.5819 12.2509C20.5819 9.55865 18.424 7.3999 15.7309 7.3999C13.0386 7.3999 10.8799 9.55865 10.8799 12.2509C10.8799 14.9432 13.0386 17.1019 15.7309 17.1019",
    fill: "#668598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.731 19.4768C11.7774 19.4768 8.40039 20.1001 8.40039 22.5935C8.40039 25.0877 11.7563 25.7331 15.731 25.7331C19.6846 25.7331 23.0616 25.1106 23.0616 22.6164C23.0616 20.1221 19.7066 19.4768 15.731 19.4768",
    fill: "#668598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpPhone);
export default __webpack_public_path__ + "static/media/SignUpPhone.5a5ff9a20d403609ebb8066cebfc7e8e.svg";
export { ForwardRef as ReactComponent };